// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "../application"

// Manually imported shared controllers

// Auto-generated controller imports
import ApplicationController from "./application_controller"
application.register("application", ApplicationController)
import ContentController from "./content_controller"
application.register("content", ContentController)
import CurrentPopperController from "./current_popper_controller"
application.register("current-popper", CurrentPopperController)
import ModalController from "./modal_controller"
application.register("modal", ModalController)
import NotificationController from "./notification_controller"
application.register("notification", NotificationController)
import PopperController from "./popper_controller"
application.register("popper", PopperController)
import PriceFieldController from "./price_field_controller"
application.register("price-field", PriceFieldController)
import RemoteFormController from "./remote_form_controller"
application.register("remote-form", RemoteFormController)
import SortableController from "./sortable_controller"
application.register("sortable", SortableController)
import StripeController from "./stripe_controller"
application.register("stripe", StripeController)
import TippyController from "./tippy_controller"
application.register("tippy", TippyController)
import TrixController from "./trix_controller"
application.register("trix", TrixController)
import UppyController from "./uppy_controller"
application.register("uppy", UppyController)
import VideoController from "./video_controller"
application.register("video", VideoController)
